@if (dataStreams && dataStreams.length) {
  <div>
    <table class="table table-striped">
      <thead>
        <th>{{ "Template.DatastreamOverviewComponent.label_dataStream" | translate }}</th>
        <th class="text-center">{{ "Template.DatastreamOverviewComponent.text_status" | translate }}</th>
        <th>{{ "Template.DatastreamOverviewComponent.label_requested" | translate }}</th>
        <th>{{ "Template.DatastreamOverviewComponent.label_responded" | translate }}</th>
      </thead>
      <tbody>
        @for (dataStream of dataStreams; track dataStream) {
          <tr>
            <td class="align-middle">
              @if (dataStream.supplier) {
                <span class="d-block">{{ dataStream.supplier.attributes?.['NAME'] }}</span>
              }
              <small class="d-block">
                {{ dataStream.supplier! | identification : "GLN" }}
              </small>
            </td>
            <td class="align-middle text-center">
              @if (dataStream.statusId == 'APPROVED') {
                <fa-icon icon="check" class="text-success"></fa-icon>
              }
              @if (dataStream.statusId == 'REQUESTED') {
                <fa-icon icon="clock" class="text-warning"></fa-icon>
              }
              @if (dataStream.statusId == 'DENIED') {
                <fa-icon icon="times" class="text-danger"></fa-icon>
              }
            </td>
            <td class="align-middle">
              @if (dataStream.requestDate) {
                <span>{{ "Template.DatastreamOverviewComponent.text_dateTime" | translate : { dateTime: dataStream.requestDate | date : "dd.MM.yyyy, HH:mm" } }}</span>
              }
            </td>
            <td class="align-middle">
              @if (dataStream.responseDate) {
                <span>{{ "Template.DatastreamOverviewComponent.text_dateTime" | translate : { dateTime: dataStream.responseDate | date : "dd.MM.yyyy, HH:mm" } }}</span>
              }
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
}

@if (!loading && !dataStreams?.length) {
  <p class="px-2">
    {{ "Template.DatastreamOverviewComponent.text_noAccessPermissionsGranted" | translate }}
  </p>
}

@if (loading) {
  <div class="p-5 text-center">
    <fa-icon icon="spinner" animation="spin" size="3x"></fa-icon>
  </div>
}
